import { UPDATE_MOCK_TEST_SUBMIT } from '../constants/actionTypes'

const defaultState = false

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_MOCK_TEST_SUBMIT:
            return action.payload
        default:
            return state
    }
}

export default reducer
